import React, { useState } from "react";

const MediaGallery = ({ items, handleDelete, handleShow }) => {
  const [playingVideo, setPlayingVideo] = useState(null);

  const getFileType = (url) => {
    if (!url) return null;
    if (url.match(/\.(mp4|webm|ogg|MP4|WEBM|OGG)$/i)) return "video";
    if (url.match(/\.(jpg|jpeg|png|gif|webp|JPG|JPEG|PNG|GIF|WEBP)$/i))
      return "image";
    return "unknown";
  };

  const handleVideoClick = (e, itemId) => {
    e.preventDefault();
    e.stopPropagation();
    setPlayingVideo(itemId);
  };

  const handleVideoEnded = () => {
    setPlayingVideo(null);
  };

  const handleDeleteClick = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    handleDelete(e, index);
  };

  return (
    <>
      {items.map((item, index) => {
        const fileType = getFileType(item.url);
        const isPlaying = playingVideo === item.id;

        return (
          <div key={item.id} className="media-item-wrapper">
            <div className="single-gallery">
              <div
                className="delicon"
                onClick={(e) => handleDeleteClick(e, index)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path d="M11 6.66797H5" stroke="#FC4F52" strokeWidth="1.5" />
                  <path
                    d="M10.6673 9H5.33398"
                    stroke="#FC4F52"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M10.3346 11.332H5.66797"
                    stroke="#FC4F52"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M13 4L12 14H4L3 4"
                    stroke="#FC4F52"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M5.33398 2H10.6673"
                    stroke="#FC4F52"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M14.6673 4H1.33398"
                    stroke="#FC4F52"
                    strokeWidth="1.5"
                  />
                </svg>
              </div>

              {fileType === "image" && (
                <a
                  onClick={() => handleShow(item?.url)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={item.url}
                    alt={item.title || "media"}
                    className="img-fluid"
                  />
                </a>
              )}

              {fileType === "video" && !isPlaying && (
                <div
                  className="video-thumbnail"
                  onClick={(e) => handleVideoClick(e, item.id)}
                  style={{ cursor: "pointer", position: "relative" }}
                >
                  <video
                    src={item.url}
                    preload="metadata"
                    className="img-fluid"
                    style={{
                      pointerEvents: "none",
                      width: "100%",
                      display: "block",
                    }}
                  />
                  <img
                    src="/assets/playicon.svg"
                    className="img-fluid play-btn"
                    alt="play"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      pointerEvents: "none",
                    }}
                  />
                </div>
              )}

              {fileType === "video" && isPlaying && (
                <video
                  src={item.url}
                  controls
                  autoPlay
                  className="img-fluid"
                  onEnded={handleVideoEnded}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                >
                  Your browser does not support the video tag.
                </video>
              )}

              {fileType === "unknown" && (
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  <div className="unknown-file">
                    <p>View File</p>
                  </div>
                </a>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default MediaGallery;
